import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../reduxService';
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
import { UnitOfMeasure } from '../../enum/project';

const initialState: IInitialState<IProjectInfoForm> = {
    initialState: true,
    data: { unitOfMeasure: UnitOfMeasure.SI, city: '', client: '', company: '', country: '', name: '', author: '' },
};

export const projectInfoSlice = createSlice({
    name: 'projectInfo',
    initialState,
    reducers: {
        cleanProjectInfo: state => {
            state.initialState = true;
            state.data = undefined;
        },
        setProjectInfo: (state, action: PayloadAction<IProjectInfoForm>) => {
            state.initialState = false;
            state.data = action.payload;
        },
        setProjectInfoTemplate: (state, action: PayloadAction<IProjectInfoForm>) => {
            state.initialState = false;
            state.data = { ...action.payload, ...state.data, type: action.payload.type, unitOfMeasure: action.payload.unitOfMeasure };
        },
    },
});

export const { setProjectInfo, cleanProjectInfo, setProjectInfoTemplate } = projectInfoSlice.actions;

export const selectProjectInfo = (state: RootState) => state.projectInfo;

export default projectInfoSlice.reducer;
